import {useEffect, useState} from "react";
import {service} from "../../stores/util";
import './i.scss'

export const SrvPop = () => {
    const [s, ss] = useState(0)
    useEffect(() => {
        service.showPop = () => {
            ss(1)
        }
    }, [])
    const cls = s ? 'act' : ''
    return <div className={'pop-srv ' + cls}>
        <div className={'clo'} onClick={() => {
            ss(0)
        }}>关闭  X
        </div>
        <div className={'ti'}><i>!</i>遇到访问问题请及时切换客服线路</div>
        {[0, 1].map(i => <div key={i}
                              className={'sim'}
                              onClick={() => {
                                  setTimeout(()=> ss(0),100)
                                  setTimeout(()=> service.open(`srv${i}`),200)
                              }}>
            <i className={'a _' + i}/>
            <div>
                <p>客服线路{i + 1}</p>
                <span>为您服务</span>
            </div>
            <i/>
        </div>)}
    </div>
}